export const setQuotes = (value, page, limit, count) => {
  return {
    type: "SET_QUOTES",
    payload: { data: value, page, limit, count },
  };
};
